import React  from 'react';
import './App.css';
import { Admin, Resource } from 'react-admin';
import {AuthShow, AuthList} from './auth';
import {UserCreate, UserEdit, UserList, UserShow} from "./user";
import {TaskList, TaskEdit} from "./task";
import {InfoShow} from "./info";
import {AuditList, AuditShow} from "./audit";
import {TrailList} from "./trail";
import { dataProvider } from "./dataProvider";
import { isAdmin, authProvider } from "./authProvider";
import { createMuiTheme } from '@material-ui/core/styles';
import Login from "./login";

const theme = createMuiTheme({
  palette: {
    type: 'light',
  },
});

const App = () => (
  <Admin loginPage={Login} theme={theme} dataProvider={dataProvider} authProvider={authProvider}>
    {role => [
      <Resource name="auth" list={AuthList} show={AuthShow} />,
      <Resource
        name="user"
        list={UserList}
        show={UserShow}
        edit={isAdmin(role) && UserEdit || null}
        create={isAdmin(role) && UserCreate || null}
      />,
      <Resource name="info" show={InfoShow} />,
      <Resource name="task" list={TaskList} edit={TaskEdit} />,
      <Resource name="audit" list={isAdmin(role) && AuditList || null} show={isAdmin(role) && AuditShow || null} />,
      <Resource name="trail" list={TrailList} />
    ]}
  </Admin>
);

export default App;


// WEBPACK FOOTER //
// ./resources/assets/js/App.js